export const BUTTON_INTENTS = Object.freeze([
  "primary",
  "secondary",
  "tertiary",
  "link",
  "danger",
  "dangerText",
  "filterChip",
  "navBack",
  "a11yLang",
  "a11yLangActive",
  "a11yTrigger",
]);

export const BUTTON_SIZES = Object.freeze([
  "small",
  "medium",
  "large",
  "wizard",
  "card",
  "compact",
  "prominent",
  "submit",
]);

export const LEGACY_VARIANT_ALIASES = Object.freeze({
  categoryPill: "filterChip",
  backPill: "navBack",
  tertiaryCta: "link",
  ctaPill: "primary",
  textButton: "tertiary",
});

export const LEGACY_SIZE_ALIASES = Object.freeze({
  cta: "wizard",
  cardAction: "card",
  action: "prominent",
});

export const BUTTON_USE_CASES = Object.freeze({
  primary: "Main forward action (filled green).",
  secondary: "Alternate outlined action.",
  tertiary: "Low-emphasis text control without underline.",
  link: "Underlined text CTA (Recover, Register now).",
  danger: "Destructive row action in forms.",
  dangerText: "Destructive text row action with no fill (drawer Logout).",
  filterChip: "Category / tab filter pill (News, Horti).",
  navBack: "Compact green breadcrumb Back control.",
  a11yLang: "Accessibility bar language switch (EN / हि), inactive.",
  a11yLangActive: "Accessibility bar language switch, selected.",
  a11yTrigger: "Accessibility bar options trigger (icon pill).",
  small: "MUI native size; recipes reset its padding (muiSizeReset).",
  medium: "MUI native size (default); recipes reset its padding.",
  large: "MUI native size; recipes reset its padding.",
  wizard: "Scheme apply wizard footer (Cancel / Next / Preview).",
  card: "Scheme/asset card row actions (Apply, View details).",
  compact: "Dense table-row actions, 8px × 12px (GRM ticket Download / View).",
  prominent: "48px paired actions (Directions / Call, dialog buttons).",
  submit: "Full-width 48px block submit (login, register, OTP).",
});
